module.exports = __webpack_public_path__ + "static/media/pay-w-btc-eth-ltc-bch-xrp-more.f4e8ff51.png";